import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const CameraHealthHelpModal = (props) => {
    const { issue, onHide } = props;
    const { t } = useTranslation('translation', { keyPrefix: 'dashboardPage.fleetCameraHealth' });

    return (
        <Modal show onHide={onHide} className="camera-health-modal camera-health-modal--help">
            <Modal.Header closeButton className={`camera-health-modal__header camera-health-modal__header--${issue.severity}`}>
                {issue.icon && <span className="camera-health-modal__header-icon"><issue.icon /></span>}
                <Modal.Title>{issue.title}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="camera-health-modal__description">{issue.description}</div>
                <div className="camera-health-modal__resolution-label">{t('labelWhatToDo')}</div>
                <ol className="camera-health-modal__resolution-list">
                    {(issue.resolutionSteps || []).map((step) => (
                        <li key={step}>{step}</li>
                    ))}
                </ol>
            </Modal.Body>
        </Modal>
    );
};

CameraHealthHelpModal.propTypes = {
    issue: PropTypes.objectOf(PropTypes.any).isRequired,
    onHide: PropTypes.func.isRequired,
};

export default CameraHealthHelpModal;
